import { throwError, Observable } from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import type { HttpEvent } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly router: Router,
    private readonly toastr: ToastrService,
    private readonly injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        const currentPath = this.router.url.split('?')[0];
        const isPublicAuthRoute = ['/login', '/logout', '/version'].includes(currentPath) || currentPath.startsWith('/sso/');

        if (err.error instanceof Error) {
          this.toastr.error('Error inesperado', '', {
            closeButton: true,
            progressBar: true
          });
        } else if (err.status === 401) {
          this.toastr.warning('Su sesión ha expirado', '', {
            closeButton: true,
            progressBar: true
          });
          if (!isPublicAuthRoute) {
            this.router.navigate(['logout']);
          }
        } else if (err.status === 403) {
          this.toastr.warning('Credenciales erroneos', '', {
            closeButton: true,
            progressBar: true
          });
        }

        return throwError(() => err);
      })
    );
  }
}
